/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetLatestDeploymentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetLatestDeploymentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetLatestDeploymentSecurity = {
  option1?: GetLatestDeploymentSecurityOption1 | undefined;
  option2?: GetLatestDeploymentSecurityOption2 | undefined;
};

export type GetLatestDeploymentRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetLatestDeploymentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetLatestDeploymentSecurityOption1$outboundSchema: z.ZodMiniType<
  GetLatestDeploymentSecurityOption1$Outbound,
  GetLatestDeploymentSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getLatestDeploymentSecurityOption1ToJSON(
  getLatestDeploymentSecurityOption1: GetLatestDeploymentSecurityOption1,
): string {
  return JSON.stringify(
    GetLatestDeploymentSecurityOption1$outboundSchema.parse(
      getLatestDeploymentSecurityOption1,
    ),
  );
}

/** @internal */
export type GetLatestDeploymentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetLatestDeploymentSecurityOption2$outboundSchema: z.ZodMiniType<
  GetLatestDeploymentSecurityOption2$Outbound,
  GetLatestDeploymentSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getLatestDeploymentSecurityOption2ToJSON(
  getLatestDeploymentSecurityOption2: GetLatestDeploymentSecurityOption2,
): string {
  return JSON.stringify(
    GetLatestDeploymentSecurityOption2$outboundSchema.parse(
      getLatestDeploymentSecurityOption2,
    ),
  );
}

/** @internal */
export type GetLatestDeploymentSecurity$Outbound = {
  Option1?: GetLatestDeploymentSecurityOption1$Outbound | undefined;
  Option2?: GetLatestDeploymentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetLatestDeploymentSecurity$outboundSchema: z.ZodMiniType<
  GetLatestDeploymentSecurity$Outbound,
  GetLatestDeploymentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetLatestDeploymentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetLatestDeploymentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getLatestDeploymentSecurityToJSON(
  getLatestDeploymentSecurity: GetLatestDeploymentSecurity,
): string {
  return JSON.stringify(
    GetLatestDeploymentSecurity$outboundSchema.parse(
      getLatestDeploymentSecurity,
    ),
  );
}

/** @internal */
export type GetLatestDeploymentRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetLatestDeploymentRequest$outboundSchema: z.ZodMiniType<
  GetLatestDeploymentRequest$Outbound,
  GetLatestDeploymentRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getLatestDeploymentRequestToJSON(
  getLatestDeploymentRequest: GetLatestDeploymentRequest,
): string {
  return JSON.stringify(
    GetLatestDeploymentRequest$outboundSchema.parse(getLatestDeploymentRequest),
  );
}
